import { Maybe } from './generated';

export const isGraphQlType = <T extends string>(typename: T) => <
  N extends { __typename?: string }
>(
  node: N,
): node is Extract<N, { __typename?: T }> => {
  return node.__typename === typename;
};

export const notMaybe = <T>(value: Maybe<T>): value is T => {
  if (value === null || value === undefined) return false;
  const testDummy: T = value; // eslint-disable-line @typescript-eslint/no-unused-vars
  return true;
};
